import React from 'react';
import { LinkButton, useAnalytics } from '../../../components';
import { getHeaderTheme } from '../themes';
export function HeaderNav({ goToBoardsText, logInText, signUpText, appearance, isLoggedIn, uuid }) {
    const eventContainer = 'uiHeader';
    const { sendTrackEvent } = useAnalytics();
    const { signup, login } = getHeaderTheme(appearance);
    switch (isLoggedIn) {
        case true:
            return (React.createElement("div", null,
                React.createElement(LinkButton, Object.assign({ url: "/" }, signup, { onClick: () => sendTrackEvent('clickedUiHeaderButton', {
                        event: 'clicked',
                        eventComponent: 'button',
                        eventContainer,
                        label: goToBoardsText !== null && goToBoardsText !== void 0 ? goToBoardsText : 'Go to Your Boards',
                        uuid: `${uuid}_goToBoards`,
                        href: '/',
                        theme: signup
                    }), "data-uuid": `${uuid}_goToBoards` }), goToBoardsText !== null && goToBoardsText !== void 0 ? goToBoardsText : 'Go to Your Boards')));
        case false:
            return (React.createElement("div", null,
                React.createElement(LinkButton, Object.assign({ url: "/login" }, login, { onClick: () => sendTrackEvent('clickedUiHeaderButton', {
                        event: 'clicked',
                        eventComponent: 'button',
                        eventContainer,
                        label: logInText !== null && logInText !== void 0 ? logInText : 'Log in',
                        uuid: `${uuid}_login`,
                        href: '/login',
                        theme: login
                    }), "data-uuid": `${uuid}_login` }), logInText !== null && logInText !== void 0 ? logInText : 'Log in'),
                React.createElement(LinkButton, Object.assign({ url: "/signup" }, signup, { onClick: () => sendTrackEvent('clickedUiHeaderButton', {
                        event: 'clicked',
                        eventComponent: 'button',
                        eventContainer,
                        label: signUpText !== null && signUpText !== void 0 ? signUpText : 'Sign up',
                        uuid: `${uuid}_signup`,
                        href: '/signup',
                        theme: signup
                    }), "data-uuid": `${uuid}_signup` }), signUpText !== null && signUpText !== void 0 ? signUpText : 'Sign up')));
        default:
            return null;
    }
}
//# sourceMappingURL=HeaderNav.js.map